/**
 * Tips category vocabulary — label, Md icon and tone per catalogue category.
 *
 * Keys mirror `src/shared/data/tips.json` `categories[].key`
 * (sleep | feeding | health | development | safety | wellbeing). Labels here
 * match the catalogue and are the fallback when a key is missing from it.
 * Tones come from the shared tone vocabulary (toneStyles.js) so every Pill,
 * Card and IconButton that renders a category gets its dark counterpart.
 */
import {
  MdBedtime,
  MdRestaurant,
  MdHealthAndSafety,
  MdToys,
  MdShield,
  MdFavorite,
  MdLightbulb,
} from '../../shared/icons';

export const TIP_CATEGORIES = {
  sleep: { key: 'sleep', label: 'Sleep', icon: MdBedtime, tone: 'sleep' },
  feeding: { key: 'feeding', label: 'Feeding', icon: MdRestaurant, tone: 'feed' },
  health: { key: 'health', label: 'Health & nappies', icon: MdHealthAndSafety, tone: 'nappy' },
  development: { key: 'development', label: 'Development & play', icon: MdToys, tone: 'activity' },
  safety: { key: 'safety', label: 'Safety', icon: MdShield, tone: 'primary' },
  wellbeing: { key: 'wellbeing', label: 'Your wellbeing', icon: MdFavorite, tone: 'health' },
};

/** Display order for chips and sections. */
export const TIP_CATEGORY_ORDER = ['sleep', 'feeding', 'health', 'development', 'safety', 'wellbeing'];

const FALLBACK = { key: 'other', label: 'Tips', icon: MdLightbulb, tone: 'warm' };

/** Category meta for a key — never undefined, so callers can render blindly. */
export function getTipCategory(key) {
  return TIP_CATEGORIES[key] || { ...FALLBACK, key: key || FALLBACK.key };
}

/** Org name from a "Org — Page" source name (the catalogue convention). */
export function sourceOrg(source) {
  const name = (source && source.name) || '';
  return name.split(' — ')[0].trim();
}
